import { render } from "./HeaderSimple.vue?vue&type=template&id=4f63135a&scoped=true"
import script from "./HeaderSimple.vue?vue&type=script&lang=ts"
export * from "./HeaderSimple.vue?vue&type=script&lang=ts"

import "./HeaderSimple.vue?vue&type=style&index=0&id=4f63135a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-4f63135a"

export default script